import { useState } from "react";

// ── Static mock data ──────────────────────────────────────── //
const MANDI_STATS = [
  { mandi: "Muhana Mandi, Jaipur",      subs: 342, sent: 340, fail: 2 },
  { mandi: "Indore Main Mandi",         subs: 218, sent: 218, fail: 0 },
  { mandi: "Ludhiana Grain Market",     subs: 196, sent: 195, fail: 1 },
  { mandi: "Nashik APMC",               subs: 167, sent: 167, fail: 0 },
  { mandi: "Koyambedu, Chennai",        subs: 143, sent: 140, fail: 3 },
  { mandi: "KR Market, Bengaluru",      subs: 121, sent: 121, fail: 0 },
];

const GROWTH_AGENTS = [
  {
    icon:   "🖼️",
    title:  "Agent 1: Post Generator",
    desc:   "Daily branded price card image for Facebook.",
    status: "Active · 7:05 AM",
    color:  "#1877F2",
  },
  {
    icon:   "🔍",
    title:  "Agent 2: SEO Content",
    desc:   "City mandi pages for Google. 48 indexed.",
    status: "Active · 48 pages",
    color:  "#16a34a",
  },
  {
    icon:   "🎁",
    title:  "Agent 3: Referral System",
    desc:   "Share 3 friends = 1 month free. 127 referrals.",
    status: "Active · 127 referrals",
    color:  "#e07b00",
  },
];

// ── Login screen ─────────────────────────────────────────── //
function AdminLogin({ onAuth }) {
  const [pin,    setPin]    = useState("");
  const [pinErr, setPinErr] = useState(false);

  const tryLogin = () => (pin === "1234" ? onAuth() : setPinErr(true));

  return (
    <div style={{ maxWidth: 360, margin: "80px auto", padding: "0 16px", textAlign: "center", fontFamily: "'DM Sans', sans-serif" }}>
      <div style={{ background: "#fff", borderRadius: 20, padding: "44px 28px", boxShadow: "0 4px 32px rgba(0,0,0,0.1)" }}>
        <div style={{ fontSize: 42, marginBottom: 12 }}>🔐</div>
        <h2 style={{ fontFamily: "'DM Serif Display', serif", color: "#1a4d2e", fontSize: 24, marginBottom: 18 }}>
          Admin Login
        </h2>
        <input
          type="password"
          placeholder="PIN (try: 1234)"
          value={pin}
          onChange={(e) => { setPin(e.target.value); setPinErr(false); }}
          onKeyDown={(e) => e.key === "Enter" && tryLogin()}
          style={{
            width:        "100%",
            padding:      "12px 14px",
            borderRadius: 10,
            border:       `1.5px solid ${pinErr ? "#ef4444" : "#d1c7b0"}`,
            fontSize:     15,
            marginBottom: 12,
            outline:      "none",
            boxSizing:    "border-box",
          }}
        />
        {pinErr && <div style={{ color: "#ef4444", fontSize: 13, marginBottom: 12 }}>Incorrect PIN</div>}
        <button
          onClick={tryLogin}
          style={{
            width:        "100%",
            padding:      "13px",
            background:   "#1a4d2e",
            color:        "#fff",
            border:       "none",
            borderRadius: 10,
            fontSize:     15,
            fontWeight:   600,
            cursor:       "pointer",
          }}
        >
          Login →
        </button>
      </div>
    </div>
  );
}

// ── Dashboard ─────────────────────────────────────────────── //
function AdminDashboard() {
  const totalSubs = MANDI_STATS.reduce((a, s) => a + s.subs, 0);
  const totalSent = MANDI_STATS.reduce((a, s) => a + s.sent, 0);

  const KPI_CARDS = [
    ["👥", totalSubs.toLocaleString(), "Total Subscribers", "#1a4d2e"],
    ["📤", totalSent.toLocaleString(), "Msgs Sent Today",   "#e07b00"],
    ["⚡", totalSubs.toLocaleString(), "Instant ACKs Sent", "#25D366"],
    ["🌐", "12",                       "Languages",          "#0891b2"],
  ];

  return (
    <div style={{ maxWidth: 980, margin: "0 auto", padding: "30px 16px 60px", fontFamily: "'DM Sans', sans-serif" }}>
      {/* Header */}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 24, flexWrap: "wrap", gap: 12 }}>
        <div>
          <h1 style={{ fontFamily: "'DM Serif Display', serif", fontSize: 28, color: "#1a4d2e" }}>Admin Dashboard</h1>
          <p style={{ color: "#9ca3af", fontSize: 13 }}>MandiMitra · {new Date().toLocaleDateString("en-IN")}</p>
        </div>
        <div style={{ background: "#f0f7f4", border: "1px solid #d4ead8", borderRadius: 10, padding: "7px 14px", fontSize: 13, color: "#1a4d2e" }}>
          🟢 Cron: Today 7:00 AM ✓
        </div>
      </div>

      {/* KPI cards */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(170px,1fr))", gap: 16, marginBottom: 24 }}>
        {KPI_CARDS.map(([icon, val, label, color]) => (
          <div key={label} style={{ background: "#fff", borderRadius: 14, padding: "18px 16px", boxShadow: "0 2px 12px rgba(0,0,0,0.07)", border: "1px solid #e8e0d0" }}>
            <div style={{ fontSize: 24, marginBottom: 6 }}>{icon}</div>
            <div style={{ fontFamily: "'DM Serif Display', serif", fontSize: 24, color, marginBottom: 2 }}>{val}</div>
            <div style={{ fontSize: 12, color: "#9ca3af" }}>{label}</div>
          </div>
        ))}
      </div>

      {/* Mandi-wise table */}
      <div style={{ background: "#fff", borderRadius: 16, overflow: "hidden", border: "1px solid #e8e0d0", marginBottom: 22, boxShadow: "0 2px 12px rgba(0,0,0,0.06)" }}>
        <div style={{ padding: "16px 20px", borderBottom: "1px solid #e8e0d0", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <h2 style={{ fontSize: 15, fontWeight: 700, color: "#1a4d2e" }}>Mandi-wise Subscribers</h2>
          <button style={{ background: "#25D366", color: "#fff", border: "none", borderRadius: 8, padding: "7px 14px", fontSize: 13, fontWeight: 600, cursor: "pointer" }}>
            📤 Send Manual Blast
          </button>
        </div>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr style={{ background: "#f0f7f4" }}>
              {["Mandi", "Subscribers", "Sent", "ACK", "Status"].map((h) => (
                <th key={h} style={{ padding: "10px 18px", textAlign: "left", fontSize: 11, fontWeight: 700, color: "#1a4d2e", textTransform: "uppercase", letterSpacing: 0.5 }}>
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {MANDI_STATS.map((s, i) => (
              <tr key={s.mandi} style={{ background: i % 2 ? "#fafaf8" : "#fff", borderBottom: "1px solid #f0ede6" }}>
                <td style={{ padding: "12px 18px", fontSize: 13 }}>{s.mandi}</td>
                <td style={{ padding: "12px 18px", fontWeight: 600, color: "#1a4d2e" }}>{s.subs}</td>
                <td style={{ padding: "12px 18px", fontSize: 13 }}>{s.sent}</td>
                <td style={{ padding: "12px 18px", fontSize: 13, color: "#25D366", fontWeight: 600 }}>⚡ {s.subs}</td>
                <td style={{ padding: "12px 18px" }}>
                  <span
                    style={{
                      background:   s.fail === 0 ? "#dcfce7" : "#fef3c7",
                      color:        s.fail === 0 ? "#15803d" : "#92400e",
                      padding:      "3px 10px",
                      borderRadius: 20,
                      fontSize:     11,
                      fontWeight:   600,
                    }}
                  >
                    {s.fail === 0 ? "✅ Done" : "⚠️ Partial"}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Growth agents */}
      <h2 style={{ fontFamily: "'DM Serif Display', serif", fontSize: 21, color: "#1a4d2e", marginBottom: 14 }}>
        🤖 Facebook Growth Agents
      </h2>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(250px,1fr))", gap: 16 }}>
        {GROWTH_AGENTS.map((a) => (
          <div key={a.title} style={{ background: "#fff", borderRadius: 14, padding: 20, border: "1px solid #e8e0d0" }}>
            <div style={{ fontSize: 28, marginBottom: 8 }}>{a.icon}</div>
            <div style={{ fontWeight: 700, fontSize: 14, color: "#1a1a1a", marginBottom: 5 }}>{a.title}</div>
            <p style={{ fontSize: 12, color: "#6b7280", lineHeight: 1.6, marginBottom: 10 }}>{a.desc}</p>
            <div style={{ background: "#f0f7f4", borderRadius: 8, padding: "5px 10px", fontSize: 12, color: a.color, fontWeight: 600 }}>
              🟢 {a.status}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

// ── AdminPage (exported) ─────────────────────────────────── //
/**
 * AdminPage
 * PIN-gated admin dashboard showing subscriber counts,
 * WhatsApp delivery stats, and growth agent statuses.
 */
export default function AdminPage() {
  const [authed, setAuthed] = useState(false);
  return authed
    ? <AdminDashboard />
    : <AdminLogin onAuth={() => setAuthed(true)} />;
}
